module.exports = __webpack_public_path__ + "img/slide01_mob.96700dad.png";